'use-client';
import classnames from 'clsx';
import * as React from 'react';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import semanticClassNames from '../../../Container.semanticClassNames';
import styles from './CustomRibbonArea.scss';

const CustomRibbonArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      renderSlot={({ containerChildren }) => (
        <>
          <div className={styles.left} />
          <div className={styles.right} />
          <div
            className={classnames(
              styles.bg,
              formatClassNames(
                semanticClassNames.root,
                ...(props.customClassNames || []),
              ),
            )}
          />
          {containerChildren}
        </>
      )}
    />
  );
};

export default React.forwardRef(CustomRibbonArea);
